<template>
    <div class="transfer-dialog">
        <el-dialog
            :visible.sync="visible"
            :title="title" left>
            <div v-if="contractInfo" class="transfer-dialog-content">
                <div class="transfer-dialog-clientinfo">
                    <div class="transfer-item flex">
                        <div class="single-item">
                            {{ $t('Common.name') }}：{{ contractInfo.clientName }}
                        </div>
                        <div class="single-item">
                            {{ $t('Common.phone') }}：{{ contractInfo.clientPhone }}
                        </div>
                    </div>
                    <div class="freeze-item flex">
                        <div class="single-item">
                            {{ $t('Contract.number') }}：{{ contractInfo.contractNum }}
                        </div>
                        <div
                            class="single-item"
                            v-if="activeName === 'member' || activeName === 'cardsCon'">
                            {{ $t('Contract.card_name') }}：{{ contractInfo.cardName }}
                        </div>
                        <div
                            class="single-item"
                            v-if="activeName === 'personal'">
                            {{ $t('Course.coach') }}：{{ contractInfo.coachNickname }}
                        </div>
                        <div
                            class="single-item"
                            v-if="activeName === 'locker'">
                            {{ $t('Common.cabinet_number') }}：{{ contractInfo.lockerCode }}
                        </div>
                    </div>
                    <div
                        class="freeze-item flex"
                        v-if="activeName === 'member' || activeName === 'cardsCon'">
                        <div class="double-item">
                            {{ $t('Contract.support_store') }}：{{ contractInfo.supportStoreNames }}
                        </div>
                    </div>
                    <div class="freeze-item flex" v-if="activeName === 'personal'">
                        <div class="single-item">
                            {{ $t('Course.name') }}：{{ contractInfo.lessonName }}
                        </div>
                        <div class="single-item">
                            {{ $t('Member.price_level') }}：{{ contractInfo.priceLevelCode }}
                        </div>
                    </div>
                    <div class="freeze-item flex" v-if="activeName === 'personal'">
                        <div class="single-item">
                            {{ $t('Sell.Pay.buy') }}：{{ contractInfo.lessonCredit }}{{ $t('Board.Team.festival') }}
                        </div>
                        <div class="single-item">
                            {{ $t('Reception.First.remaining') }}：{{ contractInfo.lessonBalance }}{{ $t('Board.Team.festival') }}
                        </div>
                    </div>
                    <div class="freeze-item flex">
                        <div
                            class="double-item"
                        >{{ $t('Common.card_number') }}：{{ contractInfo.cardName }}</div>
                    </div>
                    <div class="freeze-item flex">
                        <div class="double-item">
                            {{ $t('Contract.start_end_date') }}：
                            <span v-if="contractInfo.startAt && contractInfo.endAt">
                                {{ contractInfo.startAt }} ~ {{ contractInfo.endAt }}
                            </span>
                        </div>
                    </div>
                    <div class="freeze-item flex" v-if="activeName === 'cardsCon'">
                        <div class="single-item">
                            {{ $t('Sell.Charge.money') }}：{{ contractInfo.cardCredit }}
                        </div>
                        <div class="single-item">
                            {{ $t('Sell.Charge.current_balance') }}：{{ contractInfo.cardBalance }}
                        </div>
                    </div>
                    <div class="freeze-item flex">
                        <div class="single-item">
                            {{ $t('Sell.standard_amount') }}：{{ contractInfo.baseAmt }}
                        </div>
                        <div class="single-item">
                            {{ $t('Member.saler') }}：{{ contractInfo.contractSalesStaffNickname }}
                        </div>
                    </div>
                    <div class="freeze-item flex">
                        <div class="double-item">
                            {{ $t('Sell.Charge.paid_amount') }}：{{ contractInfo.paidAmt }}
                        </div>
                    </div>
                </div>
            </div>
            <el-form
                ref="form"
                :model="form"
                :rules="rules"
                label-suffix=":"
                label-width="120px"
                label-position="right">
                <div class="transfer-dialog-content">
                    <el-form-item :label="$t('Sell.Dialog.tranfer')" style="margin-top: 15px;">
                        <el-select
                            v-model="form.clientId"
                            v-if="!next"
                            style="width: 258px;"
                            filterable
                            remote
                            reserve-keyword
                            :placeholder="$t('Reception.Fifth.place_name_phone')"
                            v-on:change="fetchUserInfo"
                            :remote-method="fetchUser">
                            <el-option
                                v-for="item in users"
                                :key="item.id"
                                :label="item.resultText"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <template v-if="transferClient">
                        <el-form-item :label="$t('Common.name')">{{ transferClient.name }}</el-form-item>
                        <el-form-item :label="$t('Common.phone')">{{ transferClient.phone }}</el-form-item>
                    </template>
                    <el-form-item :label="$t('Member.saler')">
                        <el-select
                            v-model="form.salesStaffId"
                            v-if="!next"
                            style="width: 258px;"
                            @change="selectSaler">
                            <input
                                v-model="searchText"
                                class="search-input-all"
                                type="text" >
                            <el-option
                                v-for="(item, iindex) in filterList"
                                :key="iindex"
                                :label="item.nickname"
                                :value="Number(item.id)"
                                :disabled="item.id === 'no'">
                            </el-option>
                        </el-select>
                        <span v-if="next">{{ salerInfo.nickname }}</span>
                    </el-form-item>
                    <el-form-item :label="$t('Common.remark')">
                        <el-input
                            v-model="form.remark"
                            v-if="!next"
                            type="textarea"
                            style="width: 258px;"
                            :rows="6"></el-input>
                        <span v-if="next">{{ form.remark }}</span>
                    </el-form-item>
                </div>
                <div class="transfer-dialog-content">
                    <template v-if="transferClient && activeName === 'member'">
                        <el-form-item :label="$t('Member.member_psyid')" style="margin-top: 25px;">
                            <el-input
                                v-model="form.toBindCardPhysicalId"
                                v-if="!next"
                                style="width: 258px;"
                                type="text"
                                :placeholder="$t('Client.click_duka')" />
                            <span v-if="next">{{ form.toBindCardPhysicalId }}</span>
                        </el-form-item>
                        <el-form-item :label="$t('Common.card_number')">
                            <el-select
                                v-if="!next"
                                v-model="form.toBindCardNum"
                                style="width: 258px;"
                                filterable
                                remote
                                reserve-keyword
                                :placeholder="$t('Common.card_number_placeholder')"
                                :remote-method="fetchCard"
                                @change="selectCard">
                                <el-option
                                    v-for="item in memberCards"
                                    :key="item.id"
                                    :label="item.cardNumber"
                                    :value="item.cardNumber">
                                </el-option>
                            </el-select>
                            <span v-if="next">{{ form.toBindCardNum }}</span>
                        </el-form-item>
                    </template>
                    <el-form-item :label="$t('Contract.number')" style="margin-top: 15px;">
                        <el-input
                            v-model="form.contractNum"
                            v-if="!next"
                            type="text"
                            :placeholder="$t('Contract.fill_number')"
                            style="width:200px" class="mr-2"
                        />
                        <el-button
                            type="success"
                            v-if="!next && autoContractNum"
                            @click="getAutoContractNum">
                            {{ $t('Common.zidong') }}
                        </el-button>
                        <span v-if="next">{{ form.contractNum }}</span>
                    </el-form-item>
                    <el-form-item v-if="contractInfo" :label="$t('Reception.Fifth.fee')">
                        {{ contractInfo.feeStr }}
                    </el-form-item>
                    <el-form-item :label="$t('Charge.discount')">
                        <el-input
                            v-model.number="form.discountAmt"
                            v-if="!next"
                            style="width: 258px;"
                            :placeholder="$t('Fill.discounted_price')"
                            type="number"
                            :min="1">
                        </el-input>
                        <span v-if="next">
                            {{ form.discountAmt || 0.00 }}{{ $t('Reception.Fifth.yuan') }}
                        </span>
                    </el-form-item>
                    <el-form-item v-if="contractInfo" :label="$t('Charge.finally_money')">
                        {{ (contractInfo.fee - form.discountAmt) > 0 ? contractInfo.fee - form.discountAmt : 0 }}
                        {{ $t('Reception.Fifth.yuan') }}
                    </el-form-item>
                </div>
                <div class="flex items-top" v-if="next">
                    <div
                        class="ml-10"
                        style="width: 100px;font-size: 12px;">{{ $t('Sell.Pay.title') }}</div>
                    <div class="transfer-dialog-radio">
                        <el-radio
                            v-model="payMethodCode"
                            v-for="(item, index) in options"
                            :label="Number(item.code)"
                            :key="index">
                            {{ item.name }}
                        </el-radio>
                    </div>
                </div>
            </el-form>
            <div class="mt-10 text-center">
                <el-button type="primary" @click="submit">
                    {{ next ? $t('Common.carry_out') : $t('Common.next_step') }}
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { Dialog, DatePicker, Radio, RadioGroup } from 'element-ui';
import filterRole from '@/mixins/filterRole.js';

export default {
    name: 'transfer-dialog',
    components: {
        ElDialog: Dialog,
        ElDatePicker: DatePicker,
        ElRadio: Radio,
        ElRadioGroup: RadioGroup,
    },
    props: ['activeName'],
    mixins: [filterRole],
    data() {
        return {
            visible: false,
            title: null,
            type: null,
            contractNum: null,
            contractInfo: null,
            form: {
                clientId: null,
                salesStaffId: null,
                remark: null,
                toBindCardPhysicalId: null,
                toBindCardNum: null,
                discountAmt: null,
            },
            payMethodCode: 1,
            salerInfo: null,
            rules: {},
            users: [],
            transferClient: null,
            searchText: null,
            staffs: [],
            // 自动生成编号
            autoContractNum: false,
            storeId: null,
            // 会员卡号搜索
            memberCards: [],
            next: false,
            options: [
                {
                    code: 1,
                    name: this.$t('Sell.Pay.cash'),
                }, {
                    code: 2,
                    name: this.$t('Sell.Pay.swipe'),
                }, {
                    code: 3,
                    name: this.$t('Sell.Pay.bank'),
                }, {
                    code: 4,
                    name: this.$t('Sell.Pay.alipay'),
                }, {
                    code: 5,
                    name: this.$t('Sell.Pay.wechat'),
                }, {
                    code: 8,
                    name: this.$t('Sell.Pay.other'),
                },
            ],
        };
    },
    watch: {
        'visible'(val) {
            if (!val) this.resetForm();
        },
    },
    computed: {
        filterList() {
            if (!this.searchText) return this.staffs;
            const arr = this.staffs.filter(item =>
                item.nickname.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1);
            return arr.length ? arr : [{id: 'no', nickname: this.$t('Common.data_not_found')}];
        },
    },
    methods: {
        resetForm() {
            this.form = {
                clientId: null,
                salesStaffId: null,
                remark: null,
                toBindCardPhysicalId: null,
                toBindCardNum: null,
                discountAmt: null,
            };
            this.next = null;
        },
        open(data) {
            this.contractNum = data.contractNum;
            this.getDesc();
            this.fetchData();
        },
        getDesc() {
            if (this.activeName === 'member') {
                this.title = this.$t('Contract.Transfer.member');
                this.type = 'mshp';
            } else if (this.activeName === 'personal') {
                this.title = this.$t('Contract.Transfer.personal');
                this.type = 'coach';
            } else if (this.activeName === 'locker') {
                this.title = this.$t('Contract.Transfer.locker');
                this.type = 'locker';
            } else if (this.activeName === 'cardsCon') {
                this.title = this.$t('Contract.Transfer.cards');
                this.type = 'cz-card';
            }
        },
        fetchData() {
            API.get(`contract/${this.type}/${this.contractNum}/transfer`)
            .then(res => {
                this.contractInfo = res;
                this.storeId = res.storeId;
                this.fetchStore();
                this.fetchStaff();
                this.visible = true;
            });
        },
        fetchStore() {
            API.get(`store/${this.storeId}`).then(res => {
                this.autoContractNum = res.autoContractNum;
            });
        },
        getAutoContractNum() {
            API.get(`store/${this.storeId}/gen-contract-num`)
            .then(res => {
                this.$set(this.form, 'contractNum', res);
            });
        },
        fetchUser(val = '') {
            API.get('client/search', {
                params: {
                    keyword: val,
                    type: this.activeName === 'personal' ? 2 : null,
                },
            }).then(res => {
                this.users = res;
            });
        },
        fetchUserInfo(val) {
            const id = val;
            this.transferClient = this.users.find(el => el.id === id);
        },
        fetchCard(val = '') {
            API.get('card-number-setting/pages', {
                params: {
                    keyword: val,
                    storeIds: this.storeId,
                    status: 1,
                },
            }).then(res => {
                this.memberCards = res.content;
            });
        },
        selectCard() {
            const item = this.memberCards.find(el => el.cardNumber === this.form.toBindCardNum);
            this.form.toBindCardPhysicalId = item.physicalId;
        },
        selectSaler() {
            this.searchText = null;
            this.salerInfo = this.staffs.find(el => el.id === this.form.salesStaffId);
        },
        async fetchStaff() {
            let ids;
            if (this.activeName === 'member') ids = [5, 6];
            else if (this.activeName === 'personal') ids = [7, 8];
            else ids = null;
            this.staffs = await this.filterRole(null, ids, this.storeId);
        },
        submit() {
            // this.$refs.form.validate(valid => {
            //     if (!valid) return;
            //     else if (!this.isNext) this.isNext = true;
            //     else if (this.isNext) this.postData();
            // });
            if (!this.next) this.handleOrder();
            else if (this.next) this.handlePaid();
        },
        handleOrder() {
            this.next = true;
            const form = Object.assign({}, this.form);
            if (this.activeName !== 'member') {
                delete form.toBindCardNum;
                delete form.toBindCardPhysicalId;
            }
            API.post(`contract/${this.type}/${this.contractNum}/transfer`, form)
            .then(res => {
                if (res) {
                    this.next = true;
                    this.contractNum = res.contractNum;
                }
            });
        },
        handlePaid() {
            const form = {
                money: (this.contractInfo.fee - this.form.discountAmt) > 0
                ? this.contractInfo.fee - this.form.discountAmt : 0,
                payMethodCode: this.payMethodCode,
            };
            API.post(`contract/${this.type}/${this.contractNum}/pay`, form)
            .then(() => {
                $ele.$confirm(this.$t('Message.success'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    cancelButtonText: this.$t('Sell.small_print'),
                    type: 'warning',
                })
                .then(() => {
                    this.visible = false;
                    this.$emit('fetchData');
                })
                .catch(() => {
                    // 小票打印预览...跳转
                    if (!this.$$filterPermission('售卖-合同管理-小票打印')) return this.$router.push('/403');
                    const location = window.location;
                    const link = `${location.origin}/admin/ticket?contractNum=${this.contractNum}&activeName=${this.activeName}`;
                    window.open(link);
                });
            });
        },
    },
};
</script>
<style lang="scss">
.transfer-dialog {
    .el-dialog {
        width: 710px;
        max-height: 800px;
    }
    .el-dialog__body {
        max-height: 740px;
        overflow-y: auto;
    }
    .el-form-item__content {
        font-size: 12px;
    }
}
.transfer-dialog-content {
    width: 100%;
    border: 1px solid #e6e6e6;
    padding: 10px;
    margin-bottom: 30px;
    &:last-child {
        margin-bottom: 15px;
        padding: 0 10px;
    }
}
.transfer-dialog-clientinfo {
    width: 70%;
}
.transfer-item {
    font-size: 12px;
    width: 100%;
    .single-item {
        width: 50%;
    }
    .double-item {
        width: 100%;
    }
    div {
        margin-bottom: 14px;
    }
    &:last-child {
        div {
            margin-bottom: 0;
        }
    }
}
.transfer-dialog-radio {
    .el-radio {
        display: block;
        margin-left: 0 !important;
        margin-bottom: 35px;
    }
    .el-radio__label {
        font-size: 12px;
    }
}
</style>
